'use client';

import React, { useCallback, useContext, useMemo } from 'react';
import { UIComponent } from '../core/components';

const Context = React.createContext<{ [flag: string]: boolean }>({});

export const FeatureFlags: UIComponent<{ headers: { [flag: string]: string } }> = ({ headers, children }) => {
  const values = useMemo(() => {
    return Object.entries(headers).reduce((acc, [key, value]) => {
      if (!key.startsWith('x-flag')) {
        return acc;
      }
      return {
        ...acc,
        [key.replace(/^x-flag-/, '')]: !!value,
      };
    }, {});
  }, [headers]);
  return <Context.Provider value={values}>{children}</Context.Provider>;
};

export const useFeatureFlag = () => {
  const flags = useContext(Context);
  return useCallback(
    (flag) => {
      return flags[flag];
    },
    [flags],
  );
};
